// Module
var code = `<div class="chromecast-poster" style="height: 100%; opacity: 0.5">
  <svg
    version="1.1"
    id="Layer_1_fsdfsdf"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1920 1080"
    style="enable-background: new 0 0 1920 1080; width: 100%; height: 100%"
    xml:space="preserve">
    <path
      style="fill: #fefcfc"
      d="M609.1,540.4c0-34.8,0-69.6,0-104.4c0-3,0.3-5.9,1.7-8.6c4-7.8,13.5-10.7,21.4-6.4
      c5.1,2.7,10,5.8,15,8.6c51.4,29.7,102.8,59.4,154.2,89c1.2,0.7,2.3,1.3,3.5,2.1c14.9,9.3,14.9,30.4-0.1,39.6
      c-9.6,5.8-19.5,11.3-29.3,17c-47,27.1-94,54.2-140.9,81.4c-4.3,2.5-8.7,4.2-13.8,2.8c-7.1-1.9-11.6-7.6-11.6-15.1
      c-0.1-8.9,0-17.7,0-26.6C609.1,593.4,609.1,566.9,609.1,540.4z M739.7,546.7c-19.5,0-39,0-58.4,0c-3.8,0-3.8,0-3.3,3.9
      c0.4,3.2,1,6.4,1.3,9.6c0.2,1.9,0.9,2.8,2.9,2.9c7.6,0.6,14.6,3.4,21.4,6.7c10.2,4.9,19.9,10.6,29.8,16c2,1.1,3.5,1.1,5.5-0.1
      c6-3.8,12.2-7.3,18.3-10.9c13.9-8.2,27.7-16.4,41.5-24.7c1.2-0.7,3.3-1.3,2.7-2.9c-0.4-1.1-2.4-0.4-3.7-0.5
      C778.4,546.7,759.1,546.7,739.7,546.7z M739.7,534.4c19.8,0,39.5,0,59.2,0c0.9,0,2.4,0.7,2.7-0.7c0.2-0.9-1-1.5-1.7-2
      c-0.4-0.3-0.9-0.6-1.4-0.9c-19.8-11.7-39.5-23.4-59.2-35.1c-1.9-1.1-3.3-1.1-5.1,0c-8.1,4.5-16.2,9-24.4,13.3
      c-8.9,4.7-17.9,9.3-28.3,9.9c-1.7,0.1-2.2,1-2.4,2.5c-0.3,2.9-0.8,5.8-1.2,8.8c-0.6,4.3-0.5,4.3,3.7,4.3
      C701,534.4,720.3,534.4,739.7,534.4z M616.6,535.6c-0.1,39.4,18.1,71.9,47.7,90.2c0.7,0.4,1.3,0.9,2.1,1.3c1.1,0.5,4.9-0.7,4.9-1.6
      c0-1.5-1.6-1.5-2.5-2.3c-0.3-0.3-0.7-0.4-1-0.6c-27.2-18-42.9-43.3-44.8-75.8c-2.1-37.7,13.6-67.1,44.8-88.2
      c0.9-0.6,1.8-1.2,2.7-1.7c1-0.6,1-1,0.1-1.7c-2.1-1.7-3.8-1.6-6.1-0.1C633.6,474.9,617.9,503.5,616.6,535.6z M669.7,504.5
      c0.8-0.3,1-1.3,1.3-2.1c1.6-5.1,3.6-10.1,5.9-15c3.2-6.7,6.9-13,11.2-19c0.5-0.7,1.5-1.3,0.8-2.4c-1-1.6-4.5-2.5-6.4-1.6
      c-13,6.5-23.7,15.6-32.1,27.5c-1.1,1.6-1.1,2.4,0.6,3.4c5.2,3.3,10.6,6.3,16.4,8.5C668.2,504,668.8,504.2,669.7,504.5z
       M650.3,546.7c-3.8,0-7.5,0-11.3,0c-3.6,0-3.7,0-3.3,3.5c0.9,8.3,3.1,16.3,6.4,24c0.8,1.8,1.4,2.5,3.4,1.2
      c6.1-4.1,12.7-7.5,19.8-9.7c1.9-0.6,2-1.7,1.7-3.3c-0.8-4.4-1.5-8.7-1.6-13.1c0-1.9-0.8-2.5-2.7-2.5
      C658.6,546.7,654.5,546.7,650.3,546.7z M689.1,614c-0.2-0.4-0.5-0.8-0.8-1.3c-7.5-10.3-13.1-21.5-17-33.6c-0.7-2.1-1.6-2-3.3-1.4
      c-5.6,2.1-10.8,4.8-15.8,8c-2.7,1.7-2.7,1.8-0.8,4.5c8.1,11.2,18.4,19.8,30.8,26c0.6,0.3,1.2,0.6,1.8,0.8
      C685.6,617.5,689.2,615.3,689.1,614z M650.6,534.4c4,0,8.1,0,12.1,0c1.4,0,2.7,0,2.7-2c0.1-4.6,0.8-9.1,1.6-13.6
      c0.3-1.5-0.2-2.3-1.6-2.7c-7.3-2.3-14-6-20.5-10.1c-1.3-0.8-2.1-0.8-2.7,0.7c-3.4,8.1-5.7,16.5-6.6,25.2c-0.2,2,0.6,2.6,2.5,2.5
      C642.3,534.3,646.5,534.4,650.6,534.4z M684.7,505.9c1.8-0.6,3.6-1,5.4-1.7c11.3-4.3,21.6-10.6,32.2-16.3c1.7-0.9,1.3-1.6-0.1-2.4
      c-6.6-3.9-13.2-7.7-19.7-11.7c-2.1-1.3-2.8-0.1-3.8,1.3c-6.3,8.6-11.2,17.9-14.8,28c-0.2,0.5-0.4,1-0.6,1.5
      C683.2,505.6,683.5,506.1,684.7,505.9z M684.9,575.9c-1.7-0.2-1.3,0.8-0.9,1.7c3.7,10.4,8.8,20.1,15.4,29c0.9,1.3,1.7,1.3,3,0.5
      c6.5-3.9,12.9-7.7,19.4-11.5c1.2-0.7,1.6-1.3,0.1-2.1c-11-5.8-21.6-12.5-33.5-16.6C687.2,576.5,686,576.3,684.9,575.9z" />

    <polygon style="fill: #ffffff" points="1041.2,546.4 960.6,465.8 960.6,512.9 876.5,512.9 876.5,579.9 960.6,579.9 960.6,627 " />
    <path
      id="path_cast"
      style="fill-rule: evenodd; clip-rule: evenodd; fill: #ffffff"
      d="M1120.8,593.9v29.9h29.9
    C1150.7,607.2,1137.3,593.9,1120.8,593.9L1120.8,593.9z M1120.8,554V574c27.5,0,49.8,22.3,49.8,49.8h19.9
    C1190.6,585.2,1159.4,554,1120.8,554L1120.8,554z M1120.8,514.2v19.9c49.5,0,89.7,40.2,89.7,89.7h19.9
    C1230.4,563.2,1181.3,514.2,1120.8,514.2L1120.8,514.2z M1320.1,444.4h-179.4c-11,0-19.9,9-19.9,19.9v29.9h19.9v-29.9h179.4v139.5
    h-69.8v19.9h69.8c11,0,19.9-9,19.9-19.9V464.3C1340,453.4,1331.1,444.4,1320.1,444.4L1320.1,444.4z" />
  </svg>
</div>
`;
// Exports
export default code;